import { render, staticRenderFns } from "./TeamName.vue?vue&type=template&id=413ed536"
import script from "../../js/components/partials/TeamName.js?vue&type=script&lang=js&external"
export * from "../../js/components/partials/TeamName.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports